var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-cabinet-estates-list-cards"},_vm._l((_vm.items),function(item,i){return _c('div',{key:i,staticClass:"page-cabinet-estates-list-cards__item"},[_c('page-cabinet-estates-list-cards-item',{attrs:{"item":item,"fields":_vm.fields}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }